'use client'

import { createContext, useContext } from 'react'

const TenantThemeModeContext = createContext(false)

export const TenantThemeModeProvider = TenantThemeModeContext.Provider

export function useTenantDarkMode(): boolean {
  return useContext(TenantThemeModeContext)
}
